/* "Jak to działa": schakelaar tussen rijen, stappen kiezen (tik, pijltjes), eenmalige intro door de stappen. */
if (typeof customElements !== 'undefined' && !customElements.get('how-it-works-stepper')) {
  customElements.define(
    'how-it-works-stepper',
    class HowItWorksStepper extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.rows = Array.prototype.slice.call(this.querySelectorAll('[data-hiw-row]'));
        this.switches = Array.prototype.slice.call(this.querySelectorAll('[data-hiw-switch]'));
        this.switchEl = this.querySelector('.hiw__switch');
        this.touched = false;
        this.timer = null;
        this.current = this.getAttribute('data-first') || (this.rows[0] && this.rows[0].getAttribute('data-hiw-row'));

        this.rows.forEach(function (row) {
          var steps = Array.prototype.slice.call(row.querySelectorAll('[data-hiw-step]'));
          steps.forEach(function (btn, i) {
            btn.addEventListener('click', function () { self.interact(); self.setStep(row, i); });
            btn.addEventListener('keydown', function (event) {
              var next = null;
              if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (i + 1) % steps.length;
              if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (i - 1 + steps.length) % steps.length;
              if (event.key === 'Home') next = 0;
              if (event.key === 'End') next = steps.length - 1;
              if (next === null) return;
              event.preventDefault();
              self.interact();
              self.setStep(row, next);
              steps[next].focus();
            });
          });
          self.setStep(row, 0);
        });
        this.switches.forEach(function (btn) {
          btn.addEventListener('click', function () { self.interact(); self.show(btn.getAttribute('data-hiw-switch')); });
        });
        this.setAttribute('data-ready', '');

        var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (!reduced && 'IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(function (entries) {
            if (!entries[0].isIntersecting) return;
            self.observer.disconnect();
            self.intro();
          }, { threshold: 0.6 });
          this.observer.observe(this);
        }
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        if (this.observer) this.observer.disconnect();
      }

      interact() {
        this.touched = true;
        clearTimeout(this.timer);
      }

      rowEl(name) {
        return this.querySelector('[data-hiw-row="' + name + '"]');
      }

      show(name) {
        var self = this;
        this.current = name;
        this.rows.forEach(function (row) { row.hidden = row.getAttribute('data-hiw-row') !== name; });
        this.switches.forEach(function (btn) {
          btn.setAttribute('aria-pressed', btn.getAttribute('data-hiw-switch') === name ? 'true' : 'false');
        });
        if (this.switchEl) this.switchEl.style.setProperty('--hiw-pos', this.switches[0] && this.switches[0].getAttribute('data-hiw-switch') === name ? '0' : '1');
        var row = this.rowEl(name);
        if (row) self.setStep(row, 0);
      }

      setStep(row, i) {
        var steps = row.querySelectorAll('[data-hiw-step]');
        var panels = row.querySelectorAll('.hiw__panel');
        steps.forEach(function (btn, n) { btn.setAttribute('aria-expanded', n === i ? 'true' : 'false'); });
        panels.forEach(function (panel, n) { panel.classList.toggle('is-active', n === i); });
        var last = Math.max(steps.length - 1, 1);
        row.style.setProperty('--hiw-progress', String(i / last));
        row.setAttribute('data-step', String(i));
      }

      intro() {
        var self = this;
        var row = this.rowEl(this.current);
        if (!row || this.touched) return;
        var count = row.querySelectorAll('[data-hiw-step]').length;
        var i = 0;
        (function advance() {
          self.timer = setTimeout(function () {
            if (self.touched) return;
            i += 1;
            if (i >= count) return;
            self.setStep(row, i);
            advance();
          }, 1500);
        })();
      }
    }
  );
}
